import { BaseModal as Modal } from './BaseModal';
import { BaseModalBody, BaseModalFooter, BaseModalHeader } from './components';
var baseModalAtoms = {
  Header: BaseModalHeader,
  Body: BaseModalBody,
  Footer: BaseModalFooter
};
export var BaseModal = Object.assign(Modal, baseModalAtoms);
//# sourceMappingURL=index.js.map